import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { environment } from '../environments/environment';
import { AuthService } from './auth.service';
import { ConfigService } from './config.service';
import { DownloadService } from './download.service';
import { ExhaustiveModeService } from './exhaustive-mode.service';
import { IconService } from './icon.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent {
  private downloadService = inject(DownloadService);
  private authService = inject(AuthService);
  private iconService = inject(IconService);

  title = 'frontend';
  protected exhaustiveModeService = inject(ExhaustiveModeService);
  protected configService = inject(ConfigService);
  protected downloads = this.downloadService.downloads;

  constructor() {
    document.title = environment.title;
    if (environment.favicon) {
      document.getElementById('favicon')?.setAttribute('href', environment.favicon);
    }
  }

  refreshActivityTimer(): void {
    this.authService.resetSessionTimeout();
  }
}
